import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import styled from 'styled-components'

import { useTranslation } from 'i18n-web/i18next'
import PageTitle from 'components/Atoms/PageTitle'
import Text from 'components/Atoms/Text'
import {
  Benefits,
  EmailVerification,
  EmailVerified,
  RegisterForm,
} from 'components/Molecules/SignUp'
import { Grid as Template } from 'components/Templates'
import { getAppName } from 'models/application'
import SEO from 'seo/page'

const Column = styled(Col)`
  &:last-of-type {
    display: none;
  }

  .button + .button {
    margin-bottom: 15px;
    margin-top: 15px;
  }
  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    &:first-of-type {
      padding-right: 25px;
    }

    &:last-of-type {
      display: flex;
      padding-left: 25px;
    }
  }
`

const SignUp = ({
  application,
  loadingPage,
  queryData,
  setVerifiedEmailMessage,
  setVerifyEmailMessage,
  verifiedEmailMessage,
  verifyEmailMessage,
}) => {
  const { t } = useTranslation()
  const router = useRouter()
  const { query } = router
  const { pbs } = query

  return (
    <Template
      application={application}
      loading={loadingPage}
      hideLanguageSelector={!pbs}
      hideMenu={Boolean(pbs)}
      showBackButton>
      <SEO title={`${t('signUp.pageTitle')} | ${getAppName(application)}`} />
      <Benefits isMobile t={t} />
      <Row>
        <Col xs={7} sm={12}>
          <PageTitle gridTemplate shadow title={t('signUp.title')} />
        </Col>
      </Row>
      <Row>
        {!verifyEmailMessage && !verifiedEmailMessage && (
          <>
            <Column sm={6} xs={12}>
              <Text as="h2" className="h4 secondary">
                {t('signUp.subtitle')}
              </Text>
              <RegisterForm
                application={application}
                queryData={queryData}
                setVerifiedEmailMessage={setVerifiedEmailMessage}
                setVerifyEmailMessage={setVerifyEmailMessage}
              />
            </Column>
            <Column hiddenXs sm={6}>
              <Benefits t={t} />
            </Column>
          </>
        )}
        {verifyEmailMessage && (
          <Col xs={12}>
            <EmailVerification />
          </Col>
        )}
        {verifiedEmailMessage && (
          <Col xs={12}>
            <EmailVerified />
          </Col>
        )}
      </Row>
    </Template>
  )
}

SignUp.propTypes = {
  application: PropTypes.string,
  loadingPage: PropTypes.bool,
  queryData: PropTypes.any,
  setVerifiedEmailMessage: PropTypes.func,
  setVerifyEmailMessage: PropTypes.func,
  verifiedEmailMessage: PropTypes.bool,
  verifyEmailMessage: PropTypes.bool,
}

export default SignUp
